export default "__VITE_ASSET__0bcf24c3__"